import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


import { BotonDGView } from "./boton";
import { esFolio } from "app/logic/guias";
import * as globals from "app/resources/globals";

function folioValido(x: string): boolean {
    return !x || esFolio(x);
}

const iconoBusqueda = require("app/img/iconos/busqueda.png");

export interface RastreoModel {
    folioA: string;
    folioB: string;
}
export interface State {
    value: RastreoModel;
}

interface Props {
    value: RastreoModel;
    onChange: (x: RastreoModel) => void;
}
class RastreoView extends React.PureComponent<Props> {
    handleClick = () => {
        const value = this.props.value;
        const folios = [
            value.folioA,
            value.folioB
        ].filter(x => esFolio(x));

        globals.setState(prev => ({ ...prev, rastreo: { folios: folios, forzarState: true } }));

        history.go("/operativa/rastreo");
    }

    render() {
        const value = this.props.value;
        const colorInvalido = "#FFAAAA";
        const colorValido = "#BEE599";
        const colorTexto = (folio: string) =>
            esFolio(folio) ?
                colorValido : folio ? colorInvalido :
                    "white";

        return (
            <div
                style={{
                    width: "250px",
                    height: "250px",
                    background: "rgba(90,90,90, 1)",
                    display: "flex",
                    flexDirection: "row"
                }}
            >

                {/* Sangría */}
                <div style={{ flex: "0 1 auto", width: "23px" }} />

                <div style={{
                    display: "flex",
                    flexDirection: "column"
                }}>

                    {/* Titulo */}
                    <div style={{ display: "flex", flex: "0 1 auto", flexDirection: "column" }} >
                        <div style={{ flex: "0 1 auto", height: "20px" }} />
                        <div style={{ flex: "0 1 auto", textAlign: "left", fontWeight: "bold", fontSize: "16px", color: "white", fontFamily: "'Montserrat', sans-serif" }}>
                            RASTREO DE ENVÍOS
                        </div>
                        <div style={{ flex: "0 1 auto", height: "20px" }} />
                    </div>


                    {/* Cuadros de texto */}
                    <div style={{ display: "flex", flexDirection: "row", flex: "0 1 auto" }}>
                        <div style={{ display: "flex", flexDirection: "column", flex: "0 1 auto" }}>
                            <kea.Mask style={{
                                width: "138px",
                                height: "30px",
                                fontFamily: "monospace",
                                borderRadius: 0,
                                marginBottom: "6px",
                                backgroundColor: colorTexto(value.folioA)
                            }}
                                value={value.folioA}
                                onChange={x => this.props.onChange({ ... this.props.value, folioA: x.toUpperCase() })}
                                mask={[
                                    { char: "alphanum", count: 3, trans: "upper" },
                                    "-",
                                    { char: "digito", count: 4 }
                                ]}
                            />

                            <kea.Mask style={{
                                width: "138px",
                                height: "30px",
                                borderRadius: 0,
                                fontFamily: "monospace",
                                marginBottom: "6px",
                                backgroundColor: colorTexto(value.folioB)
                            }}
                                value={value.folioB}
                                onChange={x => this.props.onChange({ ... this.props.value, folioB: x.toUpperCase() })}
                                mask={[
                                    { char: "alphanum", count: 3, trans: "upper" },
                                    "-",
                                    { char: "digito", count: 4 }
                                ]}
                            />
                        </div>
                        <div style={{ flex: "0 1 auto", width: "12px" }} />
                        <div style={{ flex: "0 1 auto" }}>
                            <img src={iconoBusqueda} />
                        </div>
                    </div>
                    {/* Botón rastrear */}
                    <BotonDGView
                        style="pressed"
                        text="Rastrear"
                        width="90px"
                        height="34px"
                        onClick={this.handleClick}
                        disableMargin
                    />
                </div>
            </div>
        )
    }
}

export class Rastreo extends React.PureComponent<{}, { value: RastreoModel }> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
                folioA: "",
                folioB: ""
            }
        };
    }

    render() {
        return <RastreoView value={this.state.value} onChange={x => this.setState({ value: x })} />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/rastreo.tsx